import { FC } from 'react';
import { useField } from 'formik';
import { FileInput } from 'src/Components/Controls';

interface IFileFieldProps {
	name: string;
	title: string;
	setData: Function;
	isRequired: boolean;
	disabled: boolean;
	defaultValue?: any;
	accept?: string;
	multiple?: boolean;
	allowScan?: boolean;
}

/**
 * Файловое поле ввода
 */
const FileField: FC<IFileFieldProps> = (props) => {
	const {
		name,
		title,
		setData,
		allowScan = false,
		isRequired = false,
		multiple,
		disabled = false,
		accept = '',
	} = props;

	const [inputProps, meta, helpers] = useField(name);

	const onChangeValueHandler = (val: any) => {
		let value: Array<File> = [];
		if (typeof val === 'function') {
			value = val(inputProps.value);
		} else {
			value = val;
		}
		helpers.setValue(value, true);
		!!setData &&
			setData((data: any) => {
				return { ...data, [name]: value };
			});
	};

	return (
		<FileInput
			name={name}
			title={title}
			errorMsg={meta.error}
			allowScan={allowScan}
			isRequired={isRequired}
			multiple={multiple}
			accept={accept}
			disabled={disabled}
			values={inputProps.value}
			setValue={(v) => {
				return onChangeValueHandler(v);
			}}
		/>
	);
};

export default FileField;
